import axiosInstance, { axiosInstanceFast } from "./axiosInstance";

export const useCases = async (
  data: {
    filterType: string;
    firstTimeLoad: number;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post("/usecases/", data, { signal });
  return response.data;
};

export const anomalyList = async (
  data: {
    filterTime: string;
    CustomFilter: string;
    fromDate?: number;
    toDate?: number;
    loadEvents?: boolean;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/incident-list",
    data,
    { signal },
  );
  return response.data.data;
};

export const anomalyEventsDetails = async (
  data: {
    [GlobalID: string]: {
      events: {
        EventId: string;
        Time: string;
        Gid: string;
      }[];
      sensor: string;
      usecaseId: number;
      type: string;
      anomalyId: number;
      anomalousIp: string;
      anomalousIpMac: string;
    }[];
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/anomalies-events-details",
    data,
    { signal },
  );
  return response.data.data;
};

export const getAnomalyTrustedList = async (
  anomalyId: number,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/getAnomalyTrustedList/",
    {
      anomalyId: anomalyId,
    },
    { signal },
  );
  return response.data;
};

export const getAnomalyGlobalTrustedList = async (
  anomalyId: string,
  globalId: string,
  anomalyType: string,
  anomalyTime: string,
  signal?: AbortSignal,
) => {
  const payload = {
    anomalyId,
    globalId,
    anomalyType,
    anomalyTime,
  };

  const response = await axiosInstanceFast.post(
    "/anomaly/get-anomaly-trusted-list",
    JSON.stringify(payload),
    { signal },
  );
  return response.data;
};

export const getPluginsWithAction = async (
  actionType: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/getPluginsWithAction/",
    {
      actionType: actionType,
    },
    { signal },
  );
  return response.data;
};

export const getActionDropdownOld = async (
  data: {
    anomalyId: number;
    anomalyType: string;
    anomalyTime: number;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstance.post(
    "/anomalyActionsBtnDropdown/",
    data,
    { signal },
  );
  return response.data;
};

export const getActionDropdown = async (
  data: {
    anomalyId: number;
    anomalyType: string;
    anomalyTime: number;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/anomaly-actions-btnDropdown",
    data,
    { signal },
  );
  return response.data.data;
};

export const getActionFrontend = async (
  url: string,
  data: {
    template: string;
    actionId: number;
    templateFunction: string;
    automationFlag?: boolean;
  },
) => {
  const response = await axiosInstanceFast.post(url, data);
  return response.data;
};

export const getThresholdValue = async (data: any, signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/get-threshold-condition",
    data,
    { signal },
  );
  return response.data.data;
};

export const insertThresholdValue = async (data: any, signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "anomaly/insert-threshold-condition",
    data,
    { signal },
  );
  return response.data.data;
};

export const getMeshPluginTemplate = async (
  pluginId: string,
  uid: string,
  signal?: AbortSignal,
) => {
  if (!pluginId || !uid) return null;
  const { data } = await axiosInstanceFast.get(
    `/plugin/get-action-template/${pluginId}`,
    { params: { uid }, signal },
  );
  return data;
};

//Mutations
export const anomalyFixed = async (data: {
  anomalyReason: string;
  action: string;
  anomalyType: string;
  actionNote: string;
  anomalyIDs: string;
}) => {
  const response = await axiosInstance.post("/deleteAnomalyEntity/", data);
  return response.data;
};

export const addToTrustedList = async (data: {
  anomalyId: string;
  operator: string;
  trustedList: string;
  fixAllAnomalies: boolean;
  expiry?: number;
  is_datalist?: boolean;
}) => {
  const response = await axiosInstance.post("/addToTrustedlist/", data);
  return response.data;
};

export const deleteEntry = async (data: { type: string; epoch: string }) => {
  const response = await axiosInstance.post("/deleteEntry/", data);
  return response.data;
};

export const addAnomalyToEmailList = async (data: {
  timeFrame: string;
  anomaly_id: number;
  type: string;
  anomalyType: string;
}) => {
  const response = await axiosInstance.post("/addAnomalyToEmailList/", data);
  return response.data;
};

export const pcapDownload = async (pcapData: {
  eventId: string | number;
  gid: string | number;
  time: string | number;
  sensor: string;
  eventname?: string;
}) => {
  // const response = await axiosInstance.get("/pcap/", {
  //   params: data,
  //   headers: {
  //     responseType: "blob",
  //   },
  //   }
  // );
  const params = new URLSearchParams({
    eventId: pcapData.eventId.toString(),
    gid: pcapData.gid.toString(),
    time: pcapData.time.toString(),
    sensor: pcapData.sensor,
    eventname: pcapData.eventname,
  } as any);
  const url = `/pcap/?${params.toString()}`;
  try {
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${pcapData.eventId}.pcap`); // Replace 'filename.ext' with the desired file name and extension
    document.body.appendChild(link);
    console.log(link);
    link.click();
    link.remove();
    return "success";
  } catch (error) {
    console.error("Error downloading file", error);
    return new Error("Some thing went wrong");
  }
};

export const getPcapDownloadData = async (pcapData: {
  eventId: string | number;
  gid: string | number;
  time: string | number;
  sensor: string;
  eventname?: string;
}) => {
  const params = new URLSearchParams({
    eventId: pcapData.eventId.toString(),
    gid: pcapData.gid.toString(),
    time: pcapData.time.toString(),
    sensor: pcapData.sensor,
    eventname: pcapData.eventname,
  } as any);
  const url = `/pcap/?${params.toString()}`;

  const response = await axiosInstance.get(url, {
    responseType: "arraybuffer",
  });
  console.log(response);
  return response;
};

export const getTopAnomalies = async (
  data: {
    startTime?: number;
    endTime?: number;
    timeFrame?: string;
  },
  signal?: AbortSignal,
) => {
  const params = new URLSearchParams();

  if (data.startTime !== undefined)
    params.append("startTime", data.startTime.toString());
  if (data.endTime !== undefined)
    params.append("endTime", data.endTime.toString());
  if (data.timeFrame) params.append("timeFrame", data.timeFrame);

  const response = await axiosInstanceFast.get(
    `/anomaly/top-anomalies-by-score?${params.toString()}`,
    {
      signal,
    },
  );
  return response.data.data;
};

export const getAnomalyAutomationStatus = async (
  data: {
    anomalyId: number | string;
    anomalyTime: number | string;
  },
  signal?: AbortSignal,
) => {
  const { anomalyId, anomalyTime } = data;

  const payload = {
    anomalyId,
    anomalyTime,
  };

  const response = await axiosInstanceFast.post(
    "/case-management/anomaly-automation-status",
    JSON.stringify(payload),
    { signal },
  );

  return response.data;
};

export const getUserDataLists = async (signal?: AbortSignal) => {
  const response = await axiosInstance.post(
    "/getUserDataLists/",
    {},
    { signal },
  );
  return response.data;
};

export const resetTcpAnomaly = async (
  data: {
    src_ip: string;
    dest_ip: string;
    src_port: string;
    dest_port: string;
    duration?: string;
    durationUnit?: string;
    action?: string;
    globalId?: string;
    type?: string;
    anomEvtId?: number | string;
  },
  signal?: AbortSignal,
) => {
  const payload = {
    rawData: JSON.stringify(data), // <-- stringify here to match Django expectation
  };
  const response = await axiosInstance.post(
    "/blockOrUnblockTcpResetDataEach/",
    payload,
    { signal },
  );
  return response.data.data;
};

export const anomalyIncidentList = async (
  limit: number,
  page: number,
  signal?: AbortSignal,
) => {
  const payload = {
    limit,
    page,
  };
  const response = await axiosInstanceFast.post(
    "/anomaly/incident-groups-list",
    payload,
    { signal },
  );
  return response.data;
};

export const getIncidentAnomalyList = async (
  incidentId: string,
  limit: number,
  page: number,
  signal?: AbortSignal,
) => {
  const payload = {
    incidentId,
    limit,
    page,
  };
  const response = await axiosInstanceFast.post(
    "/anomaly/get-incident-anomalies",
    payload,
    { signal },
  );
  return response.data.data;
};

export const getIncidentAnomalySummary = async (
  incident_id: string,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/get-incident-summary",
    { incident_id },
    { signal },
  );
  return response.data.data;
};

export const getAnomalySensitivity = async (
  anomalyId: number,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.get(
    `/anomaly/get-custom-sensitivity/?anomaly_id=${anomalyId}`,
    { signal },
  );

  return response.data;
};

export const setCustomSensitivity = async (data: any, signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/anomaly/set-custom-sensitivity/",
    data,
    { signal },
  );
  return response.data.data;
};
